<template>
    <div>
        <ScrollTop />
        <ScrollPanel style="height: 600px">
            <!-- DIALOGO DE LOADING -->
            <Dialog :visible.sync="loading" :closable="false" :containerStyle="{ width: '300px' }">
                <ProgressBar mode="indeterminate" style="height: .5em" />
                <div
                    class="scalein animation-duration-2000 animation-iteration-infinite flex align-items-center justify-content-center font-bold border-round m-2 px-5 py-3">
                    {{ loadingMensaje }}</div>
            </Dialog>
            <!-- DIALOG DEL CORREO -->
            <Dialog :visible.sync="dialogCorreo" :style="{ width: '1000px' }" :closable="false" :modal="true">
                <Card>
                    <template #header>
                        <div class="flex justify-content-between flex-wrap pb-2">
                            <Button @click="closeDialogCorreo"> Cerrar</Button>
                            Enviar comprobante
                            <Button @click="enviaCorreo"> Enviar</Button>
                        </div>
                    </template>
                    <template #content>
                        <div class="p-d-flex justify-center p-fluid grid formgrid col-12">
                            <div class="field col-12">
                                <span class="p-float-label">
                                    <InputText v-model="correo.asunto" type="text" autofocus tabindex="1" />
                                    <label>Asunto</label>
                                </span>
                            </div>
                        </div>
                        <InlineMessage severity="info">Para agregar un DESTINATARIO primero agregue un NOMBRE y un
                            CORREO</InlineMessage>
                        <div class="p-d-flex justify-center p-fluid grid formgrid col-12">
                            <div class="field col-6">
                                <span class="p-float-label">
                                    <InputText v-model="nuevoDestinatario.nombre" type="text" ref="nombreF" />
                                    <label>Nombre</label>
                                </span>
                            </div>
                            <div class="field col-6">
                                <div class="p-inputgroup">
                                    <span class="p-float-label">
                                        <InputText v-model="nuevoDestinatario.correo" type="text"
                                            @keydown.enter="pushCorreo()" />
                                        <label>Correo</label>
                                        <Button icon="pi pi-plus" class="p-button-success" @click="pushCorreo()" />
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="p-d-flex justify-center p-fluid grid formgrid col-12">
                            <div class="field col-12">
                                <span class="p-float-label">
                                    <Chips v-model="destinatarios" :allowDuplicate="false">
                                        <template #chip="slotProps">
                                            <div>
                                                <span style="font-size: 12px">{{ slotProps.value.nombre }} - {{
                                                    slotProps.value.correo
                                                }}</span>
                                            </div>
                                        </template>
                                    </Chips>
                                    <label>Destinatarios</label>
                                </span>
                            </div>
                        </div>
                        <Editor v-model="correo.mensaje" editorStyle="height: 200px" />
                    </template>
                </Card>
            </Dialog>
            <Card>
                <template #header>
                    <Button @click="closeDialogPdf"> Cerrar</Button>
                    <Button @click="descargaComprobante"> Descargar PDF</Button>
                    <Button @click="openDialogCorreo"> Enviar</Button>
                </template>
            </Card>
            <Card>
                <template #content>
                    <div id="invoice">
                        <!-- CABECERA DEL COMPROBANTE -->
                        <div class="p-d-flex justify-center p-fluid grid formgrid col-12">
                            <div class="md:col-6">
                                <a href="https://contago.com.mx/" target="_blank">
                                    <img :src="datosEmpresa.logo.base64" width="250">
                                </a>
                            </div>
                            <div class="md:col-6 text-right">
                                <font size="4">
                                    <div><strong>Protocolo</strong></div>
                                </font>
                                <font size="3">
                                    <div>{{ datosEmpresa.rfc }}</div>
                                </font>
                                <font size="3">
                                    <div>{{ datosEmpresa.nombre }}</div>
                                </font>
                                <font size="2">
                                    <div>{{ datosEmpresa.regimenFiscal.regimenFiscal }}</div>
                                </font>
                            </div>
                        </div>
                        <!-- DATOS DEL CLIENTE -->
                        <div class="grid">
                            <div class="col text-left">
                                <font size="3">
                                    <div>Datos del cliente:</div>
                                </font>
                                <font size="3">
                                    <div><strong>{{ item.cliente.cliente }}</strong></div>
                                </font>
                                <font size="2">
                                    <div>{{ item.cliente.usoCfdi.usoCfdi }}</div>
                                </font>
                                <font size="2">
                                    <div>{{ item.cliente.domicilioFiscal }}</div>
                                </font>
                                <font size="2">
                                    <div>{{ item.cliente.direccion }}</div>
                                </font>
                            </div>
                            <div class="col text-right">
                                <h3>{{ item.serie }} {{ item.folio }}</h3>
                                <div>Fecha de entrega: {{ formatDate(item.fechaProtocolo) }}</div>
                                <!-- <div>Vigencia: {{ formatDate(item.vigencia) }}</div>
                                <div>Moneda: {{ item.moneda.clave }}</div>
                                <div>Tipo de comprobante: I | Ingreso</div> -->
                                <div>Lugar de Expedición: {{ datosEmpresa.domicilioFiscal }}</div>
                            </div>
                        </div>
                        <div class="grid">
                            <div class="col text-center">
                                <p class="font-bold" style="font-size: 12px">Proyecto</p>
                                <p style="font-size: 12px">{{ item.proyecto.descripcion }}</p>
                            </div>
                            <div class="col text-center">
                                <p class="font-bold" style="font-size: 12px">Presupuesto</p>
                                <p style="font-size: 12px">{{ formatCurrency(item.proyecto.presupuesto) }}</p>
                            </div>
                            <div class="col text-center">
                                <p class="font-bold" style="font-size: 12px">Fecha de Entrega</p>
                                <p style="font-size: 12px">{{ formatDate(item.proyecto.fechaEntrega) }}</p>
                            </div>
                        </div>

                        <!-- CONCEPTOS -->
                        <DataTable class="mt-1" :value="conceptos" responsiveLayout="scroll">
                            <Column field="noIdentificacion" header="No. Identificación"
                                :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '100%', 'text-align': 'center' }">
                            </Column>
                            <Column field="descripcion" header="Descripción" class="flex"
                                :styles="{ 'flex-grow': '1', 'flex-basis': '150px', 'font-size': '80%' }">
                                <template #body="{ data }">
                                    <h4>{{ data.descripcion }}</h4>
                                    <div>{{ data.claveProdServ.claveProdServ }}</div>
                                </template>
                            </Column>
                            <Column field="cantidadEntregar" header="Cantidad a Entregar"
                                :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '100%', 'text-align': 'center' }">
                            </Column>
                            <Column field="unidad" header="Unidad"
                                :styles="{ 'flex-grow': '1', 'flex-basis': '100px', 'font-size': '100%', 'text-align': 'center' }">
                            </Column>
                        </DataTable>
                        <div class="grid">
                            <div class="col">
                                <p style="font-size: 12px">{{ item.notas }}</p>
                            </div>
                        </div>
                    </div>
                </template>

            </Card>
            <ScrollTop target="parent" :threshold="100" class="custom-scrolltop" icon="pi pi-arrow-up" />
        </ScrollPanel>
    </div>
</template>

<script>
import moment from "moment";
import html2pdf from "html2pdf.js";
import axios from 'axios'
import { numeroALetras } from '../../plugins/numeroALetras.js'

export default {
    components: {
        // numeroALetras,
    },
    data() {
        return {
            dialogCorreo: false,
            loadingMensaje: '',
            loading: false,
            destinatarios: [],
            nuevoDestinatario: {
                nombre: '',
                correo: ''
            },
            conceptos: []
        };
    },
    computed: {
        item() {
            this.conceptos = this.$store.state.protocoloStore.conceptos.filter(a => a.cantidadEntregar != 0)
            return this.$store.state.protocoloStore;
        },
        empresa() {
            return this.$store.state.usuario;
        },

        importeLetra() {
            const func = require('../../plugins/numeroALetras.js')
            let a = func.numeroALetras(this.$store.state.protocoloStore.total);
            return a;
        },

        datosEmpresa() {
            return this.$store.state.empresaStore
        },
        itemsImpuestos() {
            var lista = [];
            var subTotal = { impuesto: 'SubTotal', importe: this.$store.state.protocoloStore.subTotal }
            lista.push(subTotal)
            for (var x of this.$store.state.protocoloStore.impuestos.traslados) {
                let nombre = '';
                let tasa = x.tasaOCuota * 100
                tasa = Math.round(tasa * 10000) / 10000
                console.log('tasa', tasa)
                if (x.impuesto === '001') {
                    nombre = 'ISR'
                }
                if (x.impuesto === '002') {
                    nombre = 'IVA'
                }
                if (x.impuesto === '003') {
                    nombre = 'IEPS'
                }


                if (x.tipoFactor === 'Exento') {
                    nombre = nombre + ' Exento'
                } else {
                    nombre = nombre + '(' + tasa + ')%'
                }

                var ob = { impuesto: nombre, importe: x.importe }
                lista.push(ob)
                ob = {};
            }
            for (var x of this.$store.state.protocoloStore.impuestos.retenciones) {
                let nombre = '';
                let tasa = x.tasaOCuota * 100
                tasa = Math.round(tasa * 10000) / 10000

                if (x.impuesto === '001') {
                    nombre = 'ISR'
                }
                if (x.impuesto === '002') {
                    nombre = 'IVA'
                }
                if (x.impuesto === '003') {
                    nombre = 'IEPS'
                }

                nombre = nombre + '(' + tasa + ')%'
                var ob = { impuesto: nombre, importe: (x.importe) * -1 }
                lista.push(ob)
                ob = {};
            }
            var total = { impuesto: 'Total', importe: this.$store.state.protocoloStore.total }
            lista.push(total)
            // console.log(lista)
            return lista;
        },

        correo() {
            return this.$store.state.correoStore
        },

    },
    created() {
        this.getCorreo();
    },
    watch: {

    },
    mounted() {

    },
    methods: {
        async getCorreo() {
            this.correo.asunto = 'Se envía documento'
            this.loadingMensaje = 'Espere...'
            this.loading = true
            let idCliente = this.item.cliente.idCliente
            try {
                let response = await axios.get('Correos/GetCorreoContacto/' + this.empresa.empresaBase + '/' + idCliente);
                console.log(response)
                let correos = response.data;
                for (let c of correos) {
                    this.destinatarios.push(c)
                }
                this.loading = false
            } catch (error) {
                console.log(error)
                this.loading = false
            }
        },
        pushCorreo() {
            if (this.nuevoDestinatario.correo === '') {
                this.$toast.add({ severity: 'error', detail: 'Error al agregar destinatario, indique un correo', life: 5000 });
                return
            }
            let nuevo = { ...this.nuevoDestinatario }
            this.destinatarios.push(nuevo)
            let inicializa = {
                nombre: '',
                correo: ''
            }
            this.nuevoDestinatario = { ...inicializa }
            this.$refs.nombreF.$el.focus();
        },
        formatDate(date) {
            moment.locale('es-mx')
            let fechaR = moment(date).format("DD-MMMM-yyyy");
            return fechaR;
        },

        formatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },

        async exportToPDF() {
            var opt = {
                margin: .5,
                filename: 'PROTOCOLO_DE_REMISION_' + this.item.serie + "_" + this.item.folio + ".pdf",
                jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
                html2canvas: { scale: 4, letterRendering: true, },
                pagebreak: {
                    mode: ['avoid-all', 'css', 'legacy']
                },
                autoPaging: 'text'
            }

            //EXPORTA EL PDF
            html2pdf().from(document.getElementById('invoice')).set(opt).toPdf().get('pdf').then((pdf) => {
                var totalPages = pdf.internal.getNumberOfPages();
                // console.log(totalPages)
                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i);
                    pdf.setFontSize(10);
                    pdf.setTextColor(0);
                    pdf.text(pdf.internal.pageSize.getWidth() - 1,
                        pdf.internal.pageSize.getHeight() - 0.1, 'Página ' + i + " / " + totalPages);
                    pdf.text(pdf.internal.pageSize.getWidth() - 5,
                        pdf.internal.pageSize.getHeight() - 0.1, 'Documento generado por contago');

                    // you can add the line separator as an image, consult the docs below to properly set the place of the image
                    // pdf.addImage(img, 'png', 0, 0, 52, 23)
                }

            }).save();
        },

        async convertBase64() {
            var opt = {
                margin: .5,
                filename: 'PROTOCOLO_DE_REMISION' + this.item.serie + "_" + this.item.folio + ".pdf",
                jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
                html2canvas: { scale: 4, letterRendering: true, },
                pagebreak: {
                    mode: ['avoid-all', 'css', 'legacy']
                },
                autoPaging: 'text'
            }

            //GENRA EL BASE64
            let file = '';
            const jabubu = await html2pdf().from(document.getElementById('invoice')).set(opt).toPdf().get('pdf').then((pdf) => {
                var totalPages = pdf.internal.getNumberOfPages();
                // console.log(totalPages)
                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i);
                    pdf.setFontSize(10);
                    pdf.setTextColor(0);
                    pdf.text(pdf.internal.pageSize.getWidth() - 1,
                        pdf.internal.pageSize.getHeight() - 0.1, 'Página ' + i + " / " + totalPages);
                    pdf.text(pdf.internal.pageSize.getWidth() - 5,
                        pdf.internal.pageSize.getHeight() - 0.1, 'Documento generado por contago');
                }

            }).outputPdf();

            file += btoa(jabubu)
            // console.log(file)
            return 'data:application/pdf;base64,' + file
        },

        async descargaComprobante() {
            await this.exportToPDF()
        },

        openDialogCorreo() {
            this.correo.archivos = []

            this.correo.archivos.push()
            this.dialogCorreo = true;
        },

        closeDialogPdf() {
            this.$emit('cierraDialogPdf')
        },

        closeDialogCorreo() {
            this.dialogCorreo = false;
        },

        async enviaCorreo() {
            this.loading = true;
            this.loadingMensaje = 'Enviando correo...'

            let correos = {
                asunto: this.correo.asunto,
                mensaje: this.correo.mensaje,
                emisor: {
                    nombre: '',
                    correo: '',
                    contra: '',
                    hostt: '',
                    puerto: 0,
                },
                receptores: [],
                archivos: [],
            }

            var pdf_ = {
                base64: await this.convertBase64(),
                nombre: this.item.serie + '_' + this.item.folio + '.pdf'
            }

            // for (let d of this.destinatarios) {
            //     var des = {
            //         nombre: '',
            //         correo: d,
            //     }
            correos.receptores = this.destinatarios;
            // des = {}
            // }

            correos.archivos.push(pdf_);

            console.log(correos)


            try {
                let response = await axios.post('Correos/PostCorreos/' + this.empresa.empresaBase + '/' + this.empresa.idusuariosApp, correos)
                console.log(response.data)
                this.dialogCorreo = false;
                this.loading = false;
                this.$toast.add({ severity: 'success', detail: 'Correo enviado con éxito', life: 5000 });

            } catch (error) {
                this.$toast.add({ severity: 'error', detail: 'Error al enviar:' + error.response.data, life: 5000 });
                console.log(error)
                this.loading = false;
            }
        },
    }
};
</script>
<style>
.col {
    background-color: white;
}

.grid {
    background-color: white;
}

.ocult thead {
    display: none;
}

.ocult table {
    border: none
}
</style>